import React from "react";
import { Link } from "react-router-dom";

const AboutFive = () => {
  return (
    <div className="section-padding-equal">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-7">
            <div className="about-team">
              <div className="thumbnail">
                <img
                  src={process.env.PUBLIC_URL + "/images/about/aboutus-2.jpg"}
                  alt="thumbnail"
                />
              </div>
            </div>
          </div>
          <div className="col-lg-5">
            <div className="about-team">
              <div className="section-heading heading-left">
                <span className="subtitle">فريقنا</span>
                <h2>معًا يمكننا فعل الكثير، وحدنا لن نفعل إلا القليل</h2>
                <p>
                  اسرة نوميديا الجوهر الاساسي في صناعة النجاح وتحقيق الانتشار
                  الواسع.{" "}
                </p>
                <Link
                  to="/team"
                  className="axil-btn btn-large btn-fill-primary"
                >
                  فريقنا
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutFive;
